import styleInject from '../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".helper-module_center_horizontal__C-xg4 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.helper-module_center_vertical__miCS- {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}";
var HelperStyles = {"center_horizontal":"helper-module_center_horizontal__C-xg4","center_vertical":"helper-module_center_vertical__miCS-"};
styleInject(css_248z);

export { HelperStyles as default };
//# sourceMappingURL=helper.module.scss.js.map
